angular.module('app')
  .factory('authFactory', function ($http, $env) {
    function url(...args) {
      return [$env.API, 'user', ...args].join('/');
    }

    return {
      logOut: () => $http.get(url('log-out')),

      getUser: () => $http.get(url()).then(response => response.data),
      updateUser: data => $http.put(url(), data).then(response => response.data),
    };
  });
